import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { formatDateTime } from './format';

dayjs.extend(relativeTime);

/** "3 days ago", with the exact date on hover. "Never" when there is no date. */
export function RelativeTime({ value, className }: { value?: string | Date | null; className?: string }) {
  const { t } = useTranslation();
  if (!value) return <span className={className}>{t('ADMIN_SHELL.COMMON.NEVER')}</span>;
  // Its own provider: usable anywhere (dialogs, tests) without relying on the app's.
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <time dateTime={new Date(value).toISOString()} className={className}>
            {dayjs(value).fromNow()}
          </time>
        </TooltipTrigger>
        <TooltipContent>{formatDateTime(value)}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
